import { type IStop, ShipmentCreatedViaEnum } from '../../../../../types/shipment'
import { useStops } from './contexts/use-stops-context'
import { StopCard } from './stop-card'

type TStopProps = {
  stop: IStop
}

/*
 * This component is used to render the stop in the stops list with inline editing
 */
export const Stop = ({ stop }: TStopProps) => {
  const { shipment } = useStops()
  const canEditStops = shipment.isShipmentOwner && shipment.createdVia !== ShipmentCreatedViaEnum.Integration

  return <StopCard stop={stop} canEditStops={canEditStops} />
}
